export const objectiveSystemsTableColumns = [
  { label: 'Nome do Sistema', value: 'display_name' },
  { label: 'Ações', value: 'actions', className: 'w-11' },
];
